import { Component, PLATFORM_ID, Inject } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { LoaderService } from './shared/services/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    private loader: LoadingBarService, private LoaderService : LoaderService) {
      this.LoaderService.showLoader();
      setTimeout(()=>{
        this.LoaderService.hideLoader();
      },3000)
    }

}
